import "components/template_journal_single/template_journal_single";
import "components/newsletter/newsletter";
import "components/share_box/share_box";